<template>
  <div
    class="base-shadow bg-background-neutral-secondary space-y-4 rounded-2xl p-4"
  >
    <CardHeader
      :flight-idx="flightIdx"
      :source-page="sourcePage"
      :dep="segmentsData.startCity"
      :arr="segmentsData.endCity"
      :duration="flight.durationText"
    />
    <MismatchedCity
      v-if="mismatchedCityNames"
      :mismatched-text="
        t('citiesMismatch.alternativeCity', mismatchedCityNames)
      "
    />
    <div v-for="(segment, idx) in flight.segments" :key="idx" class="space-y-4">
      <div
        v-if="ticketDetails.lib.isRailSegment(segment)"
        class="rounded-md bg-[#1D6BC0]/10 py-1.5 text-center text-xs font-medium uppercase text-[#1D6BC0]"
      >
        {{ t('railSegment') }}
      </div>
      <FlightDescription
        :segment="segment"
        :prev-segment-arr="segmentsData.getPrevSegmentArr(idx)"
        :next-segment-dep="segmentsData.getNextSegmentDep(idx)"
        :segment-idx="idx"
        :flight-idx="flightIdx"
        :source-page="sourcePage"
        :display-luggage="displayLuggage"
        @onNewHandLuggageClick="$emit('onNewHandLuggageClick')"
      />
      <FlightConnection
        v-if="segmentsData.isFlightConnectionVisible(idx)"
        :segment="segment"
        :next-segment="props.flight.segments[idx + 1]"
        @onItemClick="emit('onFaqItemClick', $event)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { ticketDetails } from 'shared';
  import type { Dict } from '@aviata/platform-types';

  import { MismatchedCity } from './mismatched-city';
  import { FlightDescription } from './flight-details-description';
  import { FlightConnection } from './flight-connection';
  import CardHeader from './CardHeader.vue';

  const { t } = useI18n();

  const props = withDefaults(
    defineProps<{
      sourcePage?: string;
      flight: ticketDetails.types.MappedFlight;
      cityMismatches: ticketDetails.types.MismatchedCity[] | null;
      flightIdx: number;
      dict: Dict.Entity | null;
      displayLuggage?: boolean;
    }>(),
    {
      displayLuggage: true,
    },
  );

  const emit = defineEmits<{
    (e: 'onFaqItemClick', itemKey: string): void;
    (e: 'onNewHandLuggageClick'): void;
  }>();

  const mismatchedCityNames = computed(() =>
    ticketDetails.lib.getMismatchedCityNames(
      props.dict,
      props.cityMismatches,
      props.flightIdx,
    ),
  );
  const segmentsData = computed(() =>
    ticketDetails.lib.getSegmentsData(props.flight),
  );
</script>

<i18n src="../config/locales.json"></i18n>
